import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const tabClass = ({ isActive }: { isActive: boolean }) =>
  `whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
    isActive
      ? 'border-teal-500 text-teal-600 dark:text-teal-400'
      : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300'
  }`;

/**
 * Shell de Comercial: sub-tabs Coofit Conexión | Coofit Marketing.
 * Rutas hijas: /comercial/conexion, /comercial/marketing.
 */
export const ComercialLayout: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="panel-page flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden !space-y-0">
      <div className="panel-page-header shrink-0">
        <h1 className="panel-page-title">{t('menu.comercial')}</h1>
      </div>

      <nav
        className="mb-3 flex shrink-0 gap-0.5 overflow-x-auto border-b border-slate-200 dark:border-gray-700"
        aria-label={t('menu.comercial')}
      >
        <NavLink to="/comercial/conexion" className={tabClass} end={false}>
          {t('menu.coofitConexion')}
        </NavLink>
        <NavLink to="/comercial/marketing" className={tabClass} end={false}>
          {t('menu.coofitMarketing')}
        </NavLink>
      </nav>

      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};
